<template>
    <div v-loading="loading" style="margin-top: 5%;">
        <el-upload class="upload-demo"
                   ref="upload"
                   :action="upAdress"
                   :on-preview="handlePreview"
                   :on-remove="handleRemove"
                   :file-list="fileList"
                   accept=".pdf"
                   :on-change="changeFile"
                   :on-success="success"
                   :on-error="error"
                   :headers="headers"
                   :auto-upload="false">
            <template #trigger>

                <el-button size="small"
                           type="primary">选取文件</el-button>

            </template>
            <el-button style="margin-left: 10px;"
                       size="small"
                       type="success"
                       @click="submitUpload">开始上传</el-button>
            <el-button style="margin-left: 10px;"
                       size="small"
                       type="success"
                       @click="alldownLoadFiles">下载PDF</el-button>
            <el-button size="small"
                       type="danger"
                       @click="deletePerpdf">删除</el-button>
        </el-upload>
    </div>
</template>
<script>
    import url from "@/api/config.js";
    import { personUpload,perdeletePdf,personDownload } from '@/api/div.js'

    export default {
        name: 'uploadPerform',
        data() {
            return {
                fileList: [],
                upAdress: '',
                allformData: [],
                headers: {
                    session: window.$cookies.get("session"),
                    zone: window.$cookies.get("zone"),
                },
                //已经上传的绩效文件
                attachmentsList: [],
                loading: false
            }
        },
        methods: {
            //下载个人文件
            async alldownLoadFiles() {
                this.loading = true
                let res = await personDownload({ id: this.$route.query.divid })
                console.log('下载回应', res.size)
                if (res.size === 13) {
                    this.$message.error("您暂时没有上传文件")
                } else {
                    //var blob = new Blob([res], { type: "application/zip" });
                    var blob = new Blob([res], { type: "application/pdf" });
                    var url = URL.createObjectURL(blob);
                    var link = document.createElement("a");
                    link.download = '个人pdf文件'
                    link.href = url;
                    link.click();
                }
                this.loading = false

            },
            /**循环上传pdf */
            async uploadNew() {
                this.loading = true
                const that = this
                for (let i = 0; i < this.allformData.length; i++) {
                    let res = await personUpload(this.allformData[i])
                    console.log('上传的文件', this.allformData[i].get('file').name);
                    if (res.status === 0) {
                        this.$message.success("上传成功")
                        this.allformData.splice(i, 1)
                        that.uploadNew()
                    } else {
                        this.$message.error("上传失败")
                        this.loading = false
                        this.allformData.splice(i, 1)
                        that.uploadNew()
                    }
                }
                //上传之后清空上传列表
                //that.allformData = []
                this.$refs.upload.clearFiles();
                this.loading = false
            },
            //删除pdf文件
            async deletePerpdf() {
                this.loading = true
                let res = await perdeletePdf({ id: this.$route.query.divid })
                if (res.status === 0) {
                    this.$message.success("删除成功")
                } else {
                    this.$message.error("删除失败")
                    this.loading = false
                }
                this.loading = false
            },
            /**上传pdf文件 */
            submitUpload() {
                if (this.allformData.length == 0) {
                    this.$message.error("请选择文件")
                } else {
                    this.uploadNew()
                }
            },
            /**移除事件 */
            handleRemove(file, fileList) {
                console.log('移除事件', file, fileList);
                for (let i = 0; i < this.allformData.length; i++) {
                    if (file.name === this.allformData[i].get('file').name) {
                        this.allformData.splice(i, 1)
                    }
                }
            },
            /**点击已上传文件 */
            handlePreview(file) {
                console.log(file);
            },
            /**文件状态改变 */
            changeFile(file, fileList) {
                console.log('文件列表', this.$refs.upload)
                let formData = new FormData();
                formData.append("file", file.raw)
                formData.append("id", this.$route.query.divid)
                this.allformData.push(formData)
            },
            // 上传成功
            success(response) {
                console.log('上传成功', response)
            },
            // 上传失败
            error(err) {
                console.log('上传失败', err)
            },
        },
        created() {
            if(localStorage.getItem('ipUrl')){
                let ipUrl = localStorage.getItem('ipUrl')
                this.upAdress = `${ipUrl}/div/addAttachment`
            }else{
                this.upAdress = `${url.baseUrl.dev}div/addAttachment`
            }
            
        },
        mounted() {
        },
    }
</script>
